var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-opensans",attrs:{"id":"mod"}},[_c('div',[_c('b-modal',{attrs:{"id":"modal-center","centered":"","ok-only":"","button-size":"sm","hide-header-close":"","no-close-on-backdrop":"","title":_vm.propiedades.tittle}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.propiedades.message))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }